var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-date-picker',{attrs:{"allowed-dates":_vm.isDateAllowed,"first-day-of-week":"1","full-width":"","multiple":"","show-current":""},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}})}
var staticRenderFns = []

export { render, staticRenderFns }